const TYPE_LABELS = {
  success: "Success",
  error: "Error",
  warning: "Warning",
  info: "Info",
};

const BACKEND_MESSAGE_MAP = [
  [/no active license found/i, "No active purchased license was found for this account."],
  [/insufficient purchased license count/i, "No purchased license count is available for this action."],
  [/insufficient license credits/i, "No purchased license count is available for this action."],
  [/insufficient credits/i, "Not enough balance is available for this action."],
  [/you do not have permission/i, "You are not allowed to do this action."],
  [/not authorized/i, "You are not allowed to do this action."],
  [/validation error/i, "Some required fields are missing or invalid."],
  [/failed to create device/i, "Device could not be created. Please check the form and try again."],
  [/failed to update/i, "Update could not be completed. Please try again."],
  [/failed to delete/i, "Delete could not be completed. Please try again."],
  [/device payload missing/i, "Device details could not be loaded."],
  [/imei must be exactly 15 digits/i, "IMEI must be exactly 15 digits."],
  [/device assigned/i, "Device was assigned successfully."],
  [/device unassigned/i, "Device was unassigned successfully."],
];

function toSentenceCase(text = "") {
  const trimmed = String(text || "").replace(/\s+/g, " ").trim();
  if (!trimmed) return "";
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}

function cleanupMessage(message = "") {
  return String(message || "")
    .replace(/^error:\s*/i, "")
    .replace(/^warning:\s*/i, "")
    .replace(/^failed:\s*/i, "")
    .replace(/[!]+$/g, "")
    .trim();
}

function humanizeBackendMessage(message = "", fallbackType = "info") {
  const raw = cleanupMessage(message);
  if (!raw) return TYPE_LABELS[fallbackType] || "Status";

  for (const [pattern, replacement] of BACKEND_MESSAGE_MAP) {
    if (pattern.test(raw)) return replacement;
  }

  return toSentenceCase(raw);
}

export function normalizeStatusPayload(type = "info", input = "", options = {}) {
  const nextType = ["success", "error", "warning", "info"].includes(type) ? type : "info";
  const fallbackTitle = TYPE_LABELS[nextType] || "Status";
  const preserveMessage = options?.preserveMessage === true;

  if (input && typeof input === "object" && !Array.isArray(input)) {
    const rawMessage =
      input.message ||
      input.msg ||
      input.error ||
      input.data?.msg ||
      input.data?.message ||
      input.response?.data?.msg ||
      input.response?.data?.message ||
      "";

    return {
      type: nextType,
      title: options.title || input.title || fallbackTitle,
      message: preserveMessage ? String(rawMessage || "").trim() : humanizeBackendMessage(rawMessage, nextType),
    };
  }

  return {
    type: nextType,
    title: options.title || fallbackTitle,
    message: preserveMessage ? String(input || "").trim() : humanizeBackendMessage(input, nextType),
  };
}

export function getReadableStatusMessage(input = "", type = "info") {
  return normalizeStatusPayload(type, input).message;
}
